import React from 'react';
import { HashRouter, Switch, Route } from 'react-router-dom';
import Home from './pages/Home';
import Signin from './pages/Signin';
import NotFound from './pages/NotFound';
import BookList from './pages/BookList';
import ErrorBoundary from 'react-error-boundary';

const ErrorFallbackComponent = ({ error }) => <div>{error.message}</div>;

const App = () => (
  <ErrorBoundary FallbackComponent={ErrorFallbackComponent}>
    <HashRouter>
      <Switch>
        <Route exact path='/signin' component={Signin} />
        <Route exact path='/bookList' component={BookList} />
        <Route exact path='/' component={Home} />
        <Route component={NotFound} />
      </Switch>
    </HashRouter>
  </ErrorBoundary>
);

export default App;
